export class UserIsInvalidException extends Error {
  constructor({ message = 'Usuario no válido', errorCode = '99' }) {
    super(message);
    this.name = this.constructor.name;
    this.errorCode = errorCode;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error().stack;
    }
  }
}
